export default "__VITE_ASSET__DuLjBUSq__"